"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _loadScript = _interopRequireDefault(require("load-script"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var GA4_GROUP = "ga4";

function init(_ref, sendPageView) {
  var trackingId = _ref.trackingId;
  if (!trackingId) throw new Error("GA tracking id is missing");
  if (!Array.isArray(trackingId) && typeof trackingId !== "string") throw new Error("GA trackingId should be string or string[]"); // cast trackingId to string[] to unify below implementation

  if (typeof trackingId === "string") {
    trackingId = [trackingId];
  }

  var config = {}; // https://developers.google.com/analytics/devguides/collection/gtagjs
  // only need to load the script once https://developers.google.com/tag-platform/gtagjs/install#add-products

  (0, _loadScript.default)("https://www.googletagmanager.com/gtag/js?id=".concat(trackingId[0]));
  window.dataLayer = window.dataLayer || [];

  function gtag() {
    window.dataLayer.push(arguments);
  }

  gtag("js", new Date());
  trackingId.forEach(function (id) {
    if (/UA-.*/i.test(id)) {
      gtag("config", id, {
        send_page_view: sendPageView // gtag won't work as expected if more than 1 group is set, so intended to skip `groups` here

      });
    } else if (/G-.*/i.test(id)) {
      gtag("config", id, {
        send_page_view: sendPageView,
        groups: GA4_GROUP
      });
    } else {
      throw new Error("Unsupported tracking id \"".concat(id, "\". Only id start with UA- or G- is supported now"));
    }
  });

  var setCustomDimension = function setCustomDimension() {
    var customDimensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    Object.entries(customDimensions).map(function (row) {
      var _row = (0, _slicedToArray2.default)(row, 2),
          key = _row[0],
          value = _row[1];

      config["dimension".concat(key)] = value;
    });
    trackingId.forEach(function (id) {
      gtag("config", id, Object.assign({}, config, {
        send_page_view: false
      }) // always set send_page_view to false when you call `config`, unless you want to sent page view
      );
    });
  };

  var pageView = function pageView(location, pathname) {
    var customDimensions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var params = {};
    Object.entries(customDimensions).map(function (row) {
      var _row2 = (0, _slicedToArray2.default)(row, 2),
          key = _row2[0],
          value = _row2[1];

      params["dimension".concat(key)] = value;
    });
    gtag("set", {
      page_location: location
    });
    trackingId.forEach(function (id) {
      // send the page view
      gtag("config", id, Object.assign({}, config, params, {
        page_title: window.document.title,
        page_path: pathname
      }));
    }); // call setCustomDimension() again, so that the dimensions specific to this pageview won't be persistent

    setCustomDimension(); // GA4 change to event for page view
    // https://support.google.com/analytics/answer/11403294?hl=en#zippy=%2Cgoogle-tag-websites

    gtag("event", "page_view", Object.assign({}, config, params, {
      page_title: window.document.title,
      page_path: pathname,
      page_location: location,
      send_to: GA4_GROUP
    }));
  };

  var fire = function fire(_ref2) {
    var category = _ref2.category,
        action = _ref2.action,
        label = _ref2.label,
        value = _ref2.value,
        _ref2$nonInteraction = _ref2.nonInteraction,
        nonInteraction = _ref2$nonInteraction === void 0 ? false : _ref2$nonInteraction,
        _ref2$customDimension = _ref2.customDimensions,
        customDimensions = _ref2$customDimension === void 0 ? {} : _ref2$customDimension;
    var params = {
      event_category: category,
      value: value,
      non_interaction: nonInteraction
    };
    Object.entries(customDimensions).map(function (row) {
      var _row3 = (0, _slicedToArray2.default)(row, 2),
          key = _row3[0],
          value = _row3[1];

      params["dimension".concat(key)] = value;
    }); // keep sending ordinary `event_label` to UA

    gtag("event", action, _objectSpread(_objectSpread({}, params), {}, {
      event_label: label
    })); // for GA4, try breakdown label to individual parameters
    // `label` could be: serialized JSON string, or plain non-JSON string

    try {
      // if `label` is a valid serialized JSON, parse the label as JSON object
      var parsedLabel = JSON.parse(label);
      gtag("event", action, _objectSpread(_objectSpread(_objectSpread({}, params), parsedLabel), {}, {
        send_to: GA4_GROUP
      }));
    } catch (e) {
      // if `label` is not a valid serialized JSON, silently ignore error and send as ordinary `event_label`
      gtag("event", action, _objectSpread(_objectSpread({}, params), {}, {
        event_label: label,
        send_to: GA4_GROUP
      }));
    }
  };

  return {
    setCustomDimension: setCustomDimension,
    pageView: pageView,
    fire: fire,
    tracker: gtag
  };
}